// extracted by mini-css-extract-plugin
module.exports = {"root":"DragIcon_root__1IzLU"};